import { render, staticRenderFns } from "./asset_transfer_record_dialog.vue?vue&type=template&id=5b6f4948"
import script from "./asset_transfer_record_dialog.vue?vue&type=script&lang=js"
export * from "./asset_transfer_record_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports